<template>
    <div class="wrap">
        <div class="mid">
            <img  src="~@/assets/img/lineing.png">
            <div>功能上线中...敬请期待</div>
        </div>
    </div>
</template>

<script>
export default {

}
</script>

<style lang='less' scoped>
    .wrap{
        position: relative;
        height:100%;
    }
    .mid{
        position: absolute;
        top:40%;
        left:50%;
        transform:translate(-50%,-50%);
        >div{
            text-align: center;
            font-size: 16px;
            margin-top: 20px;
        }
    }
</style>
